import { OpenPosition } from '@flipster/r230522/original/position';
import Num, { BigNumber, countDecimalPlaces } from '@flipster/utils/num';

// 해당 symbol을 사고 팔 수 있는 가장 유리한 가격 (bestOfferEstimate)
/** https://github.prex.sh/Prex/prex-api-doc/blob/develop/Variables%20and%20Functions.md#best_offer_estimate_for_flip_position */
export const calcFlipEstimatedEntryPrice = (currentPosition: OpenPosition) =>
  currentPosition.side === 'Long' ? currentPosition.bidPrice : currentPosition.askPrice;

/** https://github.prex.sh/Prex/prex-api-doc/blob/develop/Variables%20and%20Functions.md#flip_estimated_position_size */
export const calcFlipEstimatedPositionSize = (
  currentPosition: OpenPosition,
  estimatedChangeInFunds: string,
  estimatedEntryPrice: string,
  notionalMaxOrderAmount: string,
  unitOrderQty: string,
) =>
  BigNumber.min(
    Num(currentPosition.fundsInvested).plus(estimatedChangeInFunds).multipliedBy(Num(currentPosition.initLeverage)),
    Num(notionalMaxOrderAmount),
  )
    .dividedBy(estimatedEntryPrice)
    .toFixed(countDecimalPlaces(unitOrderQty))
    .toString();

/**
 *
 * @param currentPosition Current open position
 * @param estimatedEntryPrice bboPrice
 * @param margin margin pre-calculated (Cross, Isolated)
 * @param takerFeeRate (takerFeeRate for position symbol)
 */
export const calcFlipEstimatedMargin = (
  currentPosition: OpenPosition,
  estimatedEntryPrice: string,
  margin: string,
  takerFeeRate: string,
) => {
  /**
   * realizedByExistingPosition
   * max(0, margin + upnl - (abs(position) * bboPrice * takerFeeRate))
   */
  const realizedByExistingPosition = BigNumber.max(
    0,
    Num(margin)
      .plus(currentPosition.unrealizedPnl)
      .minus(Num(currentPosition.position).multipliedBy(estimatedEntryPrice).multipliedBy(takerFeeRate).abs()),
  );

  const calculatedFeeRate = Num(currentPosition.initLeverage).multipliedBy(takerFeeRate);

  if (currentPosition.marginType === 'Cross') {
    /**
     * NOTE: Cross margin position's takerFee already took from wallet margin balance
     */
    return realizedByExistingPosition.toString();
  }

  /**
   * estimatedMargin
   * realizedByExistingPosition * (1 - calculatedFeeRate)
   */
  return Num(realizedByExistingPosition).multipliedBy(Num(1).minus(calculatedFeeRate)).toString();
};
